













import { defineComponent, PropType } from '@nuxtjs/composition-api';

import BaseImage from '../BaseImage/BaseImage.vue';
import getNuxtImgConfig from './getNuxtImgConfig';

export default defineComponent({
  name: 'UCStoryblokImage',
  components: {
    BaseImage,
  },
  props: {
    src: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      required: true,
    },
    loading: {
      type: String as PropType<'lazy' | 'eager' | undefined>,
      default: 'lazy',
    },
    width: {
      type: Number,
      default: null,
    },
    height: {
      type: Number,
      default: null,
    },
    fill: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    /**
     * If sizes are provided, nuxt-img will generate srcsets automatically. see https://github.com/nuxt/image/pull/227/files/fe9f4dbf463839028dd00cd1fc948a6f541f1f01
     */
    sizes: {
      type: Object,
      default: () => null,
    },
    srcsets: {
      type: String,
      default: '',
    },
    fitIn: {
      type: Boolean,
      default: false,
    },
    preload: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    // @ts-ignore migrated from ui-library
    const nuxtImgConfig = getNuxtImgConfig(this.$props);

    return {
      nuxtImgConfig,
    };
  },
});
